import { render } from "./DeliveryTimeMapDot20.vue?vue&type=template&id=42502f62"
import script from "./DeliveryTimeMapDot20.vue?vue&type=script&lang=js"
export * from "./DeliveryTimeMapDot20.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__